module.exports = __webpack_public_path__ + "media/images/combo-ipad-metrics-revenue-97371964.png";